import { GetterTree } from 'vuex'
import * as consts from '@/utils/constants'
import { ImagesStateInterface } from '@/models/store/ImagesState.interface'
import { RootStateInterface } from '@/models/store/RootState.interface'
import { ImageInterface } from '@/models/images/Image.interface'

const extensionOf = (image: ImageInterface) =>
  (image.thumbUrl ?? image.imageUrl ?? '')
    .split('?')[0]
    .split('.')
    .pop()
    ?.toLowerCase()

const getters: GetterTree<ImagesStateInterface, RootStateInterface> = {
  // An image with no resolvable url cannot be previewed or sent.
  richCardImages(state: ImagesStateInterface) {
    return state.images.filter((image) => {
      const extension = extensionOf(image)

      return (
        !!extension && consts.RICH_CARD_IMAGE_EXTENSIONS.includes(extension)
      )
    })
  }
}

export default getters
